export class PointRankingService {
	constructor(containerService) {
		this.containerService = containerService;
	}
}
